// extracted by mini-css-extract-plugin
export default {"root":"ProductDetails_root__pdX9j","density":"ProductDetails_density__+5gBg","input":"ProductDetails_input__r-0F-","unit-selector":"ProductDetails_unit-selector__5pGCc"};